<template>
  <div class="btn__wrapper">
    <btn-select
      v-for="answer in answers"
      @click.native.once="handleClick(answer.text)"
    >
      <span class="pl">{{ answer.text }}</span>
    </btn-select>
  </div>
</template>

<script>
import BtnSelect from '../common/BtnSelect'

export default {
  components: {
    'btn-select': BtnSelect
  },
  data () {
    return {
      answers: [
        {
          text: 'Yes'
        },
        {
          text: 'No'
        }
      ]
    }
  },
  methods: {
    handleClick (value) {
      this.$emit('input', value)
    }
  }
}
</script>
